import { lazy } from '@/service/lazy'
import expiradoParceiro from './expiradoParceiro'

export default [{
  name: 'LogoutParceiro',
  path: 'logout',
  component: lazy('app/auth/login/index'),
  children: [
    ...expiradoParceiro
  ]
}]



// WEBPACK FOOTER //
// ./src/router/modules/auth/logout.js